import omitBy from 'lodash/omitBy';
import isUndefined from 'lodash/isUndefined';

export const parseError = (error) => {
  let httpStatus = error.response ? error.response.status : undefined;
  return omitBy({ httpStatus, message: error.message }, isUndefined);
};
